import { useDropzone } from 'react-dropzone'
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { MAX_IMAGE_SIZE_BYTES, MAX_IMAGE_SIZE_MB } from '../../Products/components/Dropzone'

const DropFile: React.FC<{
  loading: boolean
  setDroppedFile: (f: File) => void
  droppedFile: File
  handleConsultar: () => void
  isMobile: boolean
}> = ({ loading, setDroppedFile, droppedFile, handleConsultar, isMobile }) => {
  const [showDropzone, setShowDropzone] = useState<boolean>(true)
  const [dropError, setDropError] = useState<string>(null)

  const onDrop = (acceptedFiles: File[]) => {
    if (acceptedFiles.length === 0) return

    const file = acceptedFiles[0]

    // Verificación de tamaño
    if (file.size > MAX_IMAGE_SIZE_BYTES) {
      setDropError(`El tamaño máximo de la imagen es de ${MAX_IMAGE_SIZE_MB}MB`)
      return
    }

    setDropError('')
    setDroppedFile(file)
    setShowDropzone(false)
  }
  const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/jpg': []
    },
    multiple: false
  })

  useEffect(() => {
    fileRejections.map((files: any) =>
      files.errors.map((err: any) => {
        return err.code === 'file-invalid-type'
          ? setDropError('Solamente podés subir archivos JPG, JPEG o PNG')
          : setDropError('Error desconocido')
      })
    )
  }, [fileRejections])

  return (
    <div style={{ display: open ? 'flex' : 'none' }}>
      {showDropzone ? (
        <Box
          {...getRootProps()}
          sx={{
            width: isMobile ? 380 : 400,
            height: isMobile ? 360 : 300,
            border: '2px dashed #aaa',
            borderRadius: 4,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            cursor: 'pointer',
            backgroundColor: isDragActive ? '#f0f0f0' : '#fff',
            textAlign: 'center',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            px: 2,
            ...(isMobile && { marginTop: '30px' })
          }}
        >
          <input {...getInputProps()} />
          {!isMobile && (
            <Typography variant="h6" gutterBottom>
              {isDragActive ? 'Soltá el archivo aquí...' : 'Arrastrá una imagen o hacé click para elegir'}
            </Typography>
          )}
          <Button sx={{ marginTop: '20px' }} variant="outlined">
            Elegir archivo
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            //width: '70%',
            //maxWidth: '800px',
            margin: '20px auto',
            border: '1px solid #ccc',
            borderRadius: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: '#fff',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)'
          }}
        >
          {droppedFile && (
            <img
              src={URL.createObjectURL(droppedFile)}
              alt="preview"
              style={{
                width: '100%',
                maxHeight: '460px',
                objectFit: 'contain',
                borderRadius: 4,
                margin: '10px'
              }}
            />
          )}
          <div style={{ display: 'flex', alignContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
            <Button variant="contained" color="success" onClick={handleConsultar} disabled={loading}>
              {loading ? 'Consultando...' : 'Consultar'}
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setShowDropzone(true)
                setDroppedFile(null)
              }}
            >
              Volver
            </Button>
          </div>
        </Box>
      )}
      {dropError && (
        <Dialog open={dropError !== null} onClose={() => setDropError(null)} maxWidth="lg">
          <DialogTitle>Error en la subida de imagenes</DialogTitle>
          <DialogContent>{dropError}</DialogContent>
          <DialogActions>
            <Button onClick={() => setDropError(null)}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  )
}

export default DropFile
